import { ProductCollectionOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { Headings } from '../components/headings';
import { FreeToGetStartedText } from '../components/sub-heading';
import { WelcomeBackText } from '../components/welcome-back-heading';

export const ProductCollectionExistingUser = () => (
	<ProductCollectionOverlayTemplate size="sm">
		<Headings main={<WelcomeBackText />} sub={<FreeToGetStartedText />} />
		<SiteActivation />
	</ProductCollectionOverlayTemplate>
);
